import {ResponsiveContent} from "../ResponsiveNavTabs";
import React from "react";
import {Alert, Button, Stack} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {useAlert, useAuth} from "../../context";
import {PageTitle, SingleText} from "../_components";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";

export function ReSendEmail() {
    return <ResponsiveContent body={<SendEmailBody/>}/>
}

function SendEmailBody() {

    const navigate = useNavigate();
    const {resendVerificationEmail} = useAuth();
    const {success, error} = useAlert();

    const validationSchema = yup.object().shape({
        email: yup.string()
            .required("Email is mandatory.")
            .email("Email not valid"),
    })

    const value = {
        email: ""
    }

    function handleSubmit(values, actions) {
        resendVerificationEmail(values)
            .then(resp => {
                if (resp.success) {
                    navigate("/account/login");
                    success(<p>An email was sent to <i>{values.email}</i> with a new verification link.</p>);

                    if ("debug" in resp && config.is_debug_mode()) {
                        const to = "/account/verify-email?token=" + resp.debug?.jwt
                        success(<p><Alert.Link as={Link} to={to}>verify</Alert.Link></p>, "Verification!", {autoClose: false});
                    }
                } else {
                    error(resp.message, "Server error");
                }
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }


    return (
        <>
            <PageTitle title="Re-Send Verification Email">Did you miss the verification link? Request a new verification email.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>

                        <SingleText name="email" label="Email" maxLength="64"/>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button as={Link} variant="link" to={-1}>Go back</Button>
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            <Button type="submit" variant="primary" disabled={isSubmitting}>Submit</Button>
                        </Stack>

                    </FormikForm>
                )}
            </Formik>


        </>
    )
}